import config from '../config/config';

const EL = config.map.elev;
const ELEVATION_UNKNOWN_VALUE = EL.unknownValue;
const ELEVATION_UNKNOWN_STRING = EL.unknownString;
const ELEVATION_UNKNOWN_LABEL = EL.unknownLabel;

/**
 * 標高を取得する関数
 * @param {number} lat - 緯度
 * @param {number} lng - 経度
 * @returns {Promise<number|string>} 標高値または'不明'
 */
export async function fetchElevation(lat, lng) {
  try {
    const url = config.api.map.elev(lng, lat);
    const response = await fetch(url);
    const data = await response.json();
    if (data?.result?.elevation !== undefined) {
      return formatElevation(data.result.elevation);
    }
    return ELEVATION_UNKNOWN_LABEL;
  } catch (error) {
    return ELEVATION_UNKNOWN_LABEL;
  }
}

/**
 * 標高値を整形する関数
 * @param {number} elevation - 生の標高値
 * @returns {string|number} フォーマットされた標高値
 */
function formatElevation(elevation) {
  if (elevation === ELEVATION_UNKNOWN_VALUE || elevation === ELEVATION_UNKNOWN_STRING) {
    return ELEVATION_UNKNOWN_LABEL;
  }
  const numElevation = Number(elevation);
  if (isNaN(numElevation)) {
    return ELEVATION_UNKNOWN_LABEL;
  }
  return Math.round(numElevation);
}
